import { render, staticRenderFns } from "./Sheet.vue?vue&type=template&id=35d1f981&scoped=true&"
import script from "./Sheet.vue?vue&type=script&lang=js&"
export * from "./Sheet.vue?vue&type=script&lang=js&"
import style0 from "./Sheet.vue?vue&type=style&index=0&id=35d1f981&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d1f981",
  null
  
)

export default component.exports